<template>
  <v-app >
    <v-container class="d-flex align-items-center min-vh-100">

      <v-row class="w-100 justify-content-center">
        <v-col md="6">
          <div class="w-100">
            <div class="clearfix">
              <b-img :src="img" ></b-img>
              <h4 class="pt-3">صفحه مورد نظر یافت نشد</h4>
              <p class="text-muted" >لطفا مجددا سعی کنید.یا به صفحات قبل برگردید</p>
            </div>
            <v-row class="w-100 justify-content-center">
              <v-col md="6">
                <v-btn
                    @click="$router.go(-1)"
                    block
                    class="primary"
                >
                  برگشت
                </v-btn>
              </v-col>
              <v-col md="6">
                <v-btn
                    to="/home"
                    block
                    class="info "
                >

                  داشبورد
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>

</template>

<script>
export default {
  name: 'Page404',
  data(){
    return{
      img:require('../../assets/404.png')
    }
  }
}
</script>
<style >
@import "../../assets/styles/global.css";
@import '../../../node_modules/vuetify/dist/vuetify.min.css';
</style>
